export class Observable<S> {
  state?: S;

  subscribers: ((state?: S) => void)[] = [];

  subscribe = (cb: () => void) => {
    this.subscribers.push(cb);

    return () => {
      this.subscribers = this.subscribers.filter((sub) => sub !== cb);
    };
  };

  notifySubscribers = () => {
    for (const subscriber of this.subscribers) {
      subscriber(this.state);
    }
  };

  setState = (partialNewState: S) => {
    const newState = {
      ...this.state,
      ...partialNewState,
    };

    this.state = newState;
    this.notifySubscribers();
  };

  getState = () => {
    return this.state;
  };
}
